export enum PaymentType {
    "Paypal",
    "Conto bancario",
    "Contrassegno"
  }